export default {
  orderedCategories(categories) {
    return categories.sort((a, b) => a.order > b.order ? 1 : -1);
  },
}
